import axios from '@/axios/index'

// 区域分布接口
export function getAreaTrend(data) {
  return axios({
    url: '/api/banner/portrait/auth/circle/area/trend',
    method: 'post',
    data
  })
}

// 粉丝量级 / 互动成本接口
export function getInteractPie(data) {
  return axios({
    url: '/api/banner/portrait/interact/pie',
    method: 'post',
    data
  })
}

// 达人圈层/内容类型接口
export function getTypeColumnar(data) {
  return axios({
    url: '/api/banner/portrait/auth/circle/content/type/columnar',
    method: 'post',
    data
  })
}

// 排序指标
export function getSortLabel() {
  return axios({
    url: '/api/label/auth/sort/index/label',
    method: 'get'
  })
}

// 达人圈层/内容类型接口
export function getList(data) {
  return axios({
    url: '/api/banner/portrait/auth/rank/list',
    method: 'post',
    data
  })
}

// 产线分析总数
export function getListTotal(data) {
  return axios({
    url: '/api/banner/portrait/auth/rank/list/total',
    method: 'post',
    data
  })
}
